/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".topmost-container[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;left:0;right:0}.topmost-container.hide-scroll[_ngcontent-%COMP%]{max-height:100vh;max-width:100vw;overflow:hidden}.router-outlet-container[_ngcontent-%COMP%]{margin-top:4.5em}  .closeable-snackbar{background-color:#00c48c;color:#fff}"];
export { styles as styles };
